import { useState } from 'react'

function toISO(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

function presetRange(preset) {
  const now = new Date()
  switch (preset) {
    case 'this_month': {
      const from = new Date(now.getFullYear(), now.getMonth(), 1)
      return { from: toISO(from), to: toISO(now) }
    }
    case 'last_month': {
      const from = new Date(now.getFullYear(), now.getMonth() - 1, 1)
      const to = new Date(now.getFullYear(), now.getMonth(), 0)
      return { from: toISO(from), to: toISO(to) }
    }
    case 'last_30': {
      const from = new Date(now.getTime() - 30 * 86400000)
      return { from: toISO(from), to: toISO(now) }
    }
    case 'last_60': {
      const from = new Date(now.getTime() - 60 * 86400000)
      return { from: toISO(from), to: toISO(now) }
    }
    case 'last_90': {
      const from = new Date(now.getTime() - 90 * 86400000)
      return { from: toISO(from), to: toISO(now) }
    }
    default:
      return { from: null, to: null }
  }
}

/**
 * Modal con presets y date inputs para rango de fecha de creacion.
 * @param {string|null} initialFrom - YYYY-MM-DD o null
 * @param {string|null} initialTo - YYYY-MM-DD o null
 * @param {Function} onConfirm - (from, to) => void
 * @param {Function} onClose - () => void
 */
export default function DateRangeChipModal({ initialFrom, initialTo, onConfirm, onClose }) {
  const [from, setFrom] = useState(initialFrom || '')
  const [to, setTo] = useState(initialTo || '')

  const applyPreset = (preset) => {
    const r = presetRange(preset)
    setFrom(r.from || '')
    setTo(r.to || '')
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center" onClick={onClose}>
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-96 max-w-full" onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">
          📅 Rango de fecha de creación
        </h3>
        <div className="flex gap-2 flex-wrap mb-4">
          <button onClick={() => applyPreset('this_month')} type="button"
            className="px-3 py-1 text-xs border border-gray-200 dark:border-gray-700 rounded-full hover:bg-gray-50 dark:hover:bg-gray-700">
            Este mes
          </button>
          <button onClick={() => applyPreset('last_month')} type="button"
            className="px-3 py-1 text-xs border border-gray-200 dark:border-gray-700 rounded-full hover:bg-gray-50 dark:hover:bg-gray-700">
            Mes pasado
          </button>
          <button onClick={() => applyPreset('last_30')} type="button"
            className="px-3 py-1 text-xs border border-gray-200 dark:border-gray-700 rounded-full hover:bg-gray-50 dark:hover:bg-gray-700">
            Últimos 30 días
          </button>
          <button onClick={() => applyPreset('last_60')} type="button"
            className="px-3 py-1 text-xs border border-gray-200 dark:border-gray-700 rounded-full hover:bg-gray-50 dark:hover:bg-gray-700">
            60 días
          </button>
          <button onClick={() => applyPreset('last_90')} type="button"
            className="px-3 py-1 text-xs border border-gray-200 dark:border-gray-700 rounded-full hover:bg-gray-50 dark:hover:bg-gray-700">
            90 días
          </button>
        </div>
        <div className="space-y-3">
          <div>
            <label className="block text-xs text-gray-600 dark:text-gray-400 mb-1">Desde</label>
            <input
              type="date"
              value={from}
              onChange={e => setFrom(e.target.value)}
              className="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-600 dark:text-gray-400 mb-1">Hasta</label>
            <input
              type="date"
              value={to}
              onChange={e => setTo(e.target.value)}
              className="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
            />
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onClose}
            type="button"
            className="px-4 py-2 text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
          >
            Cancelar
          </button>
          <button
            onClick={() => { onConfirm(from || null, to || null); onClose() }}
            type="button"
            className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Aplicar
          </button>
        </div>
      </div>
    </div>
  )
}
